module.exports = __webpack_public_path__ + "img/VetoSans-Light_3.6dfcace1.svg";